// A VOZ DO PRODUTO É UM ARQUIVO, NÃO O QUE A MÁQUINA TIVER.
//
// A tipografia era a pilha do sistema: SF no Mac, Segoe no Windows, Roboto no
// Android. Três produtos diferentes, e o tema pedindo `cv05` — uma variante de
// caractere do Inter — a uma fonte que nunca era carregada, ou seja, nada. Aqui
// o Inter Variable é servido pelo próprio domínio, com `font-display: swap` e
// subconjunto por `unicode-range`: nada sai para CDN nenhum, que é a mesma
// promessa que este produto faz sobre os números do usuário.
import '@fontsource-variable/inter';

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
